require('./bootstrap-vue')
require('./veeValidate')
require('./style.css')
require('./sweetalert2')
require('./typeahead')
require('./typeaheadboostrap')
require('./vue-slick-carousel')